(function () {
  'use strict';
  var configNode = document.getElementById('welp-quote-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  var allowed = new WeakSet();
  var pending = new WeakSet();
  function customQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      var handle = item.handle || item.product_handle;
      return total + (Number(item.product_id) === 15418083147864 || handle === 'custom-hype-chain-builder' ? Number(item.quantity) || 0 : 0);
    }, 0);
  }
  function requiresQuote(cart) {
    var quantity = customQuantity(cart);
    if (quantity > 24) return true;
    if (!quantity) return false;
    var minimum = new Date();
    minimum.setHours(12, 0, 0, 0);
    minimum.setDate(minimum.getDate() + (quantity <= 5 ? 18 : quantity <= 9 ? 21 : 28));
    var minimumDate = minimum.getFullYear() + '-' + String(minimum.getMonth() + 1).padStart(2, '0') + '-' + String(minimum.getDate()).padStart(2, '0');
    return (cart.items || []).some(function (item) {
      var handle = item.handle || item.product_handle;
      if (Number(item.product_id) !== 15418083147864 && handle !== 'custom-hype-chain-builder') return false;
      var requested = String((item.properties || {})['Event / Needed-By Date'] || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(requested)) return true;
      var parts = requested.split('-').map(Number);
      var parsed = new Date(parts[0], parts[1] - 1, parts[2], 12);
      if (parsed.getFullYear() !== parts[0] || parsed.getMonth() !== parts[1] - 1 || parsed.getDate() !== parts[2]) return true;
      return requested < minimumDate;
    });
  }
  function checkoutForm(form, submitter) {
    if (submitter && submitter.name === 'checkout') return true;
    try { return new URL(form.action, location.href).pathname.replace(/\/$/, '') === '/checkout'; }
    catch (error) { return false; }
  }
  function showError(form) {
    var node = form.querySelector('[data-welp-quote-error]');
    if (!node) {
      node = document.createElement('p');
      node.setAttribute('data-welp-quote-error', '');
      node.setAttribute('role', 'alert');
      form.appendChild(node);
    }
    node.textContent = config.error;
  }
  function checkCart() {
    return fetch(config.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !checkoutForm(form, event.submitter)) return;
    if (allowed.has(form)) { allowed.delete(form); return; }
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    var submitter = event.submitter;
    checkCart().then(function (cart) {
      if (requiresQuote(cart)) { location.assign(config.quoteUrl); return; }
      allowed.add(form);
      if (submitter && submitter.isConnected) form.requestSubmit(submitter);
      else form.requestSubmit();
    }).catch(function () { allowed.delete(form); showError(form); })
      .finally(function () { pending.delete(form); });
  }, true);
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, location.href); } catch (error) { return; }
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    checkCart().then(function (cart) { location.assign(requiresQuote(cart) ? config.quoteUrl : url.href); })
      .catch(function () { location.assign(config.cartPage); });
  }, true);
})();